export enum VirtualProductType {
  Unknown = 0,
  Trip = 1,
  FlightTicket = 2,
  Voucher = 3,
  FlightTicketReturn = 4,
  TripReturn = 5,
  ETravel = 6,
  ETravelReturn = 7,
}
